//Stateler çekilip return edilecek

export const getUserLoading = (state) => {
    return state.loading
}

export const login = (state) => {
    return state.login
}

export const getUsers = (state) => {
    return state.users
}

export const getUserStatus = (state) => {
    return state.userStatus
}

export const getUserMenus = (state) => {
    return state.menus
}

export const getAuth = (state) => {
    return state.auth
}

export const getUserTypes = (state) => {
    return state.types
}

export const getUserPageInfo = (state) => {
    return state.userPageInfo
}

export const getLogs = (state) => {
    return state.logs
}

export const getLogsPageInfo = (state) => {
    return state.logsPageInfo
}
export const getUserDetail = (state) => {
    return state.user
}
export const getAuthCasbin = (state) => {
    return state.authCasbin
}
export const getAuthsCasbin = (state) => {
    return state.authsCasbin
}
export const getAuthMenus = (state) => {
    return state.authMenus
}
export const getCustomWidgets = (state) => {
    return state.widgets
}
export const getWidgetVal = (state) => {
    return state.widgetVal
}



// WEBPACK FOOTER //
// ./src/store/modules/Users/Getters.js